import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tab } from '../generic-tab-group/generic-tab-group.component';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-navigation-tab',
  imports: [RouterModule, MatTabsModule, TranslateModule],
  templateUrl: `./navigation-tab.component.html`,
  styleUrl: './navigation-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationTabComponent {
  /** 
   * Signal input for the navigation links. 
   */
  navLinks = input.required<Tab[]>();
}
